class CartAddonsByCountry extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.cartItems = document.querySelector("cart-items");
    this.sectionsToRender = this.getSectionsToRender();
  }

  init() {
    let options = window.countryList.map((country) => {
      return {
        label: country.name_localized,
        value: country.code.toLowerCase(),
      };
    });

    options.sort((a, b) => a.label.localeCompare(b.label));

    const initVirtualSelect = async () => {
      let selectedCountry = await this.getCountry();

      const waitForVirtualSelect = () => {
        if (typeof VirtualSelect !== "undefined") {
          VirtualSelect.init({
            ele: "#shipping-country__select",
            search: true,
            placeholder: "Země",
            maxValues: 1,
            alwaysShowSelectedOptionsLabel: true,
            options: options,
            searchPlaceholderText: "Zadejte název země",
            selectedValue: selectedCountry,
            required: true,
            hideClearButton: true,
            searchNormalize: true,
            searchByStartsWith: true,
            labelRenderer: this.labelRenderer,
          });
        } else {
          setTimeout(waitForVirtualSelect, 100); // Check again after 100 milliseconds
        }
      };

      waitForVirtualSelect();
    };

    initVirtualSelect().catch((error) => {
      console.error("Error:", error);
    });

    const shippingCountrySelect = this.querySelector(
      "#shipping-country__select"
    );

    if (shippingCountrySelect) {
      shippingCountrySelect.addEventListener("change", (e) =>
        this.onCountryChange.bind(this)(e)
      );
    }
  }

  onCountryChange(e) {
    e.preventDefault();
    let selectButton = this.querySelector(".vscomp-toggle-button");
    let flagSrc = this.getFlagSource(e.target.value);
    if (selectButton?.querySelector("img")) {
      // if img elm exists, replace the src
      selectButton.querySelector("img").src = flagSrc;
    } else {
      // create img elm and prepend it to the button
      let flagElm = document.createElement("img");
      flagElm.setAttribute("class", "flag-icon");
      flagElm.src = flagSrc;
      this.querySelector(".vscomp-toggle-button")?.prepend(flagElm);
    }

    // set cookie with selected country
    let countryHandle = e.target.value;
    this.setCookie("selected_shipping_country", countryHandle, 5);

    // country check and add fee if needed
    this.initFee();
  }

  getFlagSource(countryCode) {
    let flagSrc;
    let spanishRegions = ["es-ce", "es-ml", "es-cn"];
    let frenchRegions = ["mf", "bl"];
    if (spanishRegions.includes(countryCode)) {
      flagSrc = `https://cdn.shopify.com/static/images/flags/es.svg`;
    } else if (frenchRegions.includes(countryCode)) {
      flagSrc = `https://cdn.shopify.com/static/images/flags/fr.svg`;
    } else {
      flagSrc = `https://cdn.shopify.com/static/images/flags/${countryCode}.svg`;
    }
    return flagSrc;
  }

  getBrowserContext() {
    return fetch(
      window.Shopify.routes.root + "browsing_context_suggestions.json"
    )
      .then((r) => r.json())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async initFee() {
    let selectedCountryHandle = this.getCookie("selected_shipping_country");
    let cartItems = await this.getCartItems();
    let isEUCountry = this.isEUCountry(selectedCountryHandle);
    let cites_ii = cartItems.find((item) => item.cites_ii == true);
    let cites_i = cartItems.find((item) => item.cites_i == true);

    // if non-EU, add fee if applicable
    if (!isEUCountry) {
      // when only cites_ii are in cart, add phyto fee

      if (cites_ii && cites_i == undefined) {
        this.handleFees(true, false);
      }

      // when cites_i are in cart, add both phyto and cites fee
      if (cites_i) {
        this.handleFees(true, true);
      }

      // when no cites are in cart, remove fee if any
      if (cites_ii == undefined && cites_i == undefined) {
        this.handleFees(false, false);
      }
    }

    // if EU, remove fee if any in cart
    if (isEUCountry) {
      this.handleFees(false, false);
    }
  }

  labelRenderer(data) {
    let flagElm = "";
    let flagSrc;

    let spanishRegions = ["es-ce", "es-ml", "es-cn"];
    let frenchRegions = ["mf", "bl"];
    if (spanishRegions.includes(data.value)) {
      flagSrc = `https://cdn.shopify.com/static/images/flags/es.svg`;
    } else if (frenchRegions.includes(data.value)) {
      flagSrc = `https://cdn.shopify.com/static/images/flags/fr.svg`;
    } else {
      flagSrc = `https://cdn.shopify.com/static/images/flags/${data.value}.svg`;
    }

    if (!data.isCurrentNew && !data.isNew) {
      if (data.value) flagElm = `<img class="flag-icon" src="${flagSrc}"/>`;
    }
    return `${flagElm} ${data.label}`;
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  connectedCallback() {
    let cartTotals = document.querySelector(".main-cart-footer-js-contents");

    if (cartTotals) {
      const observer = new MutationObserver((mutations) => {
        for (let i = 0; i < mutations.length; i++) {
          if (i == 0) {
            // check state of cart items
            this.initFee();
          }
        }
      });

      observer.observe(cartTotals, {
        characterData: true,
        childList: true,
        subtree: true,
        attributes: true,
      });
    } else {
      console.error("Subtotal element is not found");
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  getCartItems() {
    let cartItems = JSON.parse(
      document.getElementById("cart-items-json")?.textContent
    ).cartItems;
    if (cartItems) return cartItems;
    return undefined;
  }

  isEUCountry(countryCode) {
    return window.euCountries.includes(countryCode);
  }

  async handleFees(phyto, cites) {
    let citesFee = window.feeItems.find((item) => item.fee_type == "cites");
    let phytoFee = window.feeItems.find((item) => item.fee_type == "phyto");
    let cartItems = await this.getCartItems();

    this.togglePurchase("disable");

    let phytoFeeInCart = cartItems.find(
      (item) => item.variant_id == phytoFee.variant_id
    );
    let citesFeeInCart = cartItems.find(
      (item) => item.variant_id == citesFee.variant_id
    );

    if (phyto && !cites) {
      // add phyto fee
      // remove cites fee
      if (phytoFeeInCart == undefined) {
        await this.addToCart([phytoFee.variant_id], 1);
      }
      if (citesFeeInCart != undefined) {
        await this.removeFromCart([citesFee.variant_id]);
      }
    }

    if (cites) {
      // add phyto fee + cites fee
      if (phytoFeeInCart == undefined && citesFeeInCart == undefined) {
        await this.addToCart([phytoFee.variant_id, citesFee.variant_id], 1);
      }
      if (phytoFeeInCart == undefined && citesFeeInCart != undefined) {
        await this.addToCart([phytoFee.variant_id], 1);
      }
      if (phytoFeeInCart != undefined && citesFeeInCart == undefined) {
        await this.addToCart([citesFee.variant_id], 1);
      }
    }

    if (!phyto && !cites) {
      // remove phyto fee + cites fee
      if (phytoFeeInCart != undefined && citesFeeInCart != undefined) {
        await this.removeFromCart([phytoFee.variant_id, citesFee.variant_id]);
      }
      if (phytoFeeInCart != undefined && citesFeeInCart == undefined) {
        await this.removeFromCart([phytoFee.variant_id]);
      }
      if (citesFeeInCart != undefined && phytoFeeInCart == undefined) {
        await this.removeFromCart([citesFee.variant_id]);
      }
    }

    this.togglePurchase("enable");
  }

  async addToCart(productIds, quantity) {
    this.performCartUpdate(routes.cart_add_url, productIds, quantity);
  }

  async removeFromCart(productIds) {
    this.performCartUpdate(routes.cart_update_url, productIds, 0);
  }

  performCartUpdate(cartUrl, productIds, quantity) {
    let jsonBody;
    if (quantity != 0) {
      let formData = {
        items: [],
        sections: this.sectionsToRender.map((section) => section.section),
      };
      productIds.forEach((productId) => {
        formData.items.push({
          id: productId,
          quantity: quantity,
        });
      });
      jsonBody = JSON.stringify(formData);
    } else {
      let formData = {
        updates: {},
        sections: this.sectionsToRender.map((section) => section.section),
      };
      productIds.forEach((productId) => {
        formData.updates[productId] = 0;
      });
      jsonBody = JSON.stringify(formData);
    }

    fetch(`${cartUrl}`, {
      ...this.fetchConfig(),
      ...{ body: jsonBody },
    })
      .then((response) => {
        if (response.ok) {
          console.log(`Fee(s) updated`);
        } else {
          console.error("Failed to add fee to cart");
        }
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.cartItems?.classList.toggle(
          "is-empty",
          parsedState.item_count === 0
        );
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        const cartDiscount = document.querySelector(".cart__discount");
        if (cartDiscount)
          cartDiscount.dataset.total = parsedState.items_subtotal_price;

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        document.getElementById("main-cart-footer");
        this.sectionsToRender.forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              ?.querySelector(section.selector) ||
            document.getElementById(section.id);

          if (!elementToReplace || !document.querySelector(section.selector))
            return;

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
      });
  }

  async getCountry() {
    let selectedCountry;
    if (this.getCookie("selected_shipping_country") == "") {
      const context = await this.getBrowserContext();
      selectedCountry = context.detected_values.country.handle.toLowerCase();
    } else {
      selectedCountry = this.getCookie("selected_shipping_country");
    }
    return selectedCountry;
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id,
        selector: ".main-cart-footer-js-contents",
      },
      {
        id: "main-cart-discount",
        section: document.getElementById("main-cart-discount")?.dataset.id,
        selector: ".cart__discount",
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`,
      },
    };
  }

  togglePurchase(action) {
    let mainCheckoutButton = document.querySelector(
      ".cart__checkout-button#checkout"
    );
    let dynamicCheckoutButtonWrapper = document.querySelector(
      ".cart__dynamic-checkout-buttons"
    );

    if (action == "disable") {
      if (mainCheckoutButton) mainCheckoutButton.style.pointerEvents = "none";
      if (dynamicCheckoutButtonWrapper)
        dynamicCheckoutButtonWrapper.style.pointerEvents = "none";
    }

    if (action == "enable") {
      if (mainCheckoutButton) mainCheckoutButton.style.pointerEvents = "auto";
      if (dynamicCheckoutButtonWrapper)
        dynamicCheckoutButtonWrapper.style.pointerEvents = "auto";
    }
  }
}

customElements.define("cart-addons-by-country", CartAddonsByCountry);
